import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
  useContext,
} from "react";
import axios from "axios";

import { useParams, Link } from "react-router-dom";
import Select from "react-select";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import jsPDF from "jspdf";
import JsBarcode from "jsbarcode";
// import { Closed, Noimage } from "../../../common/imagePath";
//import { Field, Form, Formik } from "formik";

import * as XLSX from "xlsx";

import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "../../../assets/css/customersummary.css";
import "jspdf-autotable";
import { toastError, toastSuccess, toastWarn } from "../../../common/Toast";
import Moment from "moment";

//--------Material React Table------//
import { MaterialReactTable } from "material-react-table";
import {
  Box,
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {
  CUSTOM_SELECT_DROPDOWN_STYLE,
  CUSTOM_SELECT_DROPDOWN_STYLE_COMBINE,
} from "../../../common/Constant";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import { Noimage } from "../../../common/imagePath";
import CommonDatePicker from "../../../components/DatePicker/CommonDatePicker";
import { checkUserPermission } from "../../../common/UserPermission";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { AppContext } from "../../../context/AppContext";

const currentDate = new Date();
const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const month = monthNames[currentDate.getMonth()]; // add 1 to get month value from 1 to 12
const hours = currentDate.getUTCHours();
const minutes = currentDate.getUTCMinutes();

const ReceivingCustomReport = (props) => {
  let PERMISSION_SHOW_COST_PRICE = "show-cost-price";
  let PERMISSION_SHOW_PROFIT_PRICE = "show-profit-price";
  const { CurrencySymbol, FractionDigits, dateFormate } =
    useContext(AppContext);
  const locationid = localStorage.getItem("Location");
  const loginuserid = localStorage.getItem("ID");
  const gridRef = useRef();
  const token = localStorage.getItem("Token");
  const [loading, setLoading] = useState(false);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [itemQuantityData, setItemQuantityData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [selectedOption, setSelectedOption] = useState([]);
  const [selectedCondition, setSelectedCondition] = useState([]);
  const [matchType, setMatchtype] = useState();
  const [matchTypeId, setMatchTypeId] = useState(1);
  const [isReceiveItem, setIsReceiveItem] = useState(0);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [custoptions, setCustOptions] = useState([]);
  const [supoptions, setSupOptions] = useState([]);
  const [usersDropdown, setUsersDropdown] = useState([]);
  const [roletierdropdown, setRoleTierDropDown] = useState([]);
  const [selectedLabels, setSelectedLabels] = useState([]);
  const [manufacturedropdwonData, setManufactureDropdwon] = useState([]);
  const [SecondCategories, setSecondCategories] = useState([]);
  //   const [customerValue, setCustomerValue] = useState();
  const [inputFilterValue, setInputFilterValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  const [inputValue, setInputValue] = useState("");
  const [searchItemName, setSearchItemName] = useState("");
  const [searchParentItem, setSearchParentItem] = useState("");
  const [ReceivingId, setReceivingId] = useState(0);
  const [showList, setShowList] = useState([]);
  const [showDateFilterModal, setShowDateFilterModal] = useState(false);
  const [OldCustomDate, setOldCustomDate] = useState(0);
  const [customeDate, setCustomDate] = useState(3);
  const [beginningDate, setBeginningDate] = useState(
    moment().startOf("month").format("MM-DD-YYYY")
  );
  const [finalDate, setFinalDate] = useState(
    moment().endOf("month").format("MM-DD-YYYY")
  );
  const [startOldDate, setStartOldDate] = useState("");
  const [endOldDate, setEndOldDate] = useState("");
  const [rowsData, setRowsData] = useState([
    {
      SelectectDropdownId: "",
      SelectectConditionId: "",
      SelectedOptions: "",
      SelectedItemRowsOptions: [],
    },
  ]);
  const [totalSum, setTotalSum] = useState(0);
  const [subTotalSum, setSubTotalSum] = useState(0);
  const [profitSum, setProfitSum] = useState(0);
  const ITEMS_PER_PAGE = 10;

  const barcodeRefs = useRef([]);
  let index = 0;
  const [data, setData] = useState({
    inputValue: "",
    width: 1,
    height: 20,
    fontSize: 15,
    zeroFill: 10,
  });

  console.log(selectedLabels, "selectedLabels");
  console.log(itemQuantityData, "itemQuantityData");
  console.log(rowsData, "rowsDataff");

  //Function to generate barcode
  const generateBarcodes = () => {
    barcodeRefs.current.forEach((barcodeRef, index) => {
      console.log("barcodeRefs", barcodeRefs);
      var g = document.getElementsByTagName(barcodeRef);
      const barcodeValue = paramObject.id;
      console.log("barcodeValue", barcodeValue);
      const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0");
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        width: data.width,
        height: data.height,
        fontSize: data.fontSize,
        displayValue: true,
        fontoptions: "bold",
        textAlign: "center",
        font: "monospace",
        textPosition: "bottom",
        textMargin: 2,
        margin: 10,
        marginTop: undefined,
        marginBottom: undefined,
        marginLeft: undefined,
        marginRight: undefined,
        format: "CODE128",
        valid: () => true,
        background: "#ffffff",
        lineColor: "#000000",
        padding: data.zeroFill,
      });
    });
  };

  const paramObject = useParams();
  const dateOptions = [
    { label: "All", value: 8 },
    { label: "Today", value: 1 },
    { label: "This Week", value: 4 },
    { label: "This Month", value: 3 },
    { label: "Last Month", value: 6 },
    { label: "This Year", value: 5 },
    { label: "Last Year", value: 2 },
    { label: "Custom", value: 7 },
    // { label: "Select", value: 0 },
  ];

  //Today
  let today = moment().format("MM-DD-YYYY");
  //Week
  const startOfWeek = moment().startOf("week").format("MM-DD-YYYY");
  const endOfWeek = moment().endOf("week").format("MM-DD-YYYY");
  //This Month
  const startOfMonth = moment().startOf("month").format("MM-DD-YYYY");
  const endOfMonth = moment().endOf("month").format("MM-DD-YYYY");
  //Last Month
  const startOfLastMonth = moment()
    .subtract(1, "month")
    .startOf("month")
    .format("MM-DD-YYYY");
  const endOfLastMonth = moment()
    .subtract(1, "month")
    .endOf("month")
    .format("MM-DD-YYYY");
  //This Year
  const startOfYear = moment().startOf("year").format("MM-DD-YYYY");
  const endOfYear = moment().endOf("year").format("MM-DD-YYYY");
  //Last Year
  const startOfLastYear = moment()
    .subtract(1, "year")
    .startOf("year")
    .format("MM-DD-YYYY");
  const endOfLastYear = moment()
    .subtract(1, "year")
    .endOf("year")
    .format("MM-DD-YYYY");

  const handleDateFilter = (event) => {
    setShowDateFilterModal(true);
    setOldCustomDate(customeDate);
    console.log(event, "eventtt");
    setCustomDate(event?.value);
    if (event?.value == 1) {
      setBeginningDate(today);
      setFinalDate(today);
    } else if (event?.value == 4) {
      setBeginningDate(startOfWeek);
      setFinalDate(endOfWeek);
    } else if (event?.value == 3) {
      setBeginningDate(startOfMonth);
      setFinalDate(endOfMonth);
    } else if (event?.value == 6) {
      setBeginningDate(startOfLastMonth);
      setFinalDate(endOfLastMonth);
    } else if (event?.value == 5) {
      setBeginningDate(startOfYear);
      setFinalDate(endOfYear);
    } else if (event?.value == 2) {
      setBeginningDate(startOfLastYear);
      setFinalDate(endOfLastYear);
    } else if (event?.value == 8) {
      setBeginningDate("");
      setFinalDate("");
    } else if (event?.value == null) {
      setBeginningDate("");
      setFinalDate("");
      setCustomDate();
    }
  };

  //Date
  const handleDate = (event) => {
    setStartOldDate(beginningDate);
    // console.log(beginningDate, "From:")
    // console.log(event[0], "eventisss92");
    setBeginningDate(event);
    setCustomDate(7);
    setShowDateFilterModal(true);
  };

  const handleEndDate = (event) => {
    setEndOldDate(finalDate);
    setFinalDate(event);
    setCustomDate(7);
    setShowDateFilterModal(true);
  };

  const handleInputChange = (e, index) => {
    const updatedRows = [...rowsData];
    updatedRows[index].SelectedOptions = e.target.value;
    setRowsData(updatedRows);
    setInputFilterValue(updatedRows);

    console.log(updatedRows, "updatedRowsinput");
  };

  const handleSearchInputChange = (event, index) => {
    console.log(event.target.value, "");
    setInputValue(event.target.value);
  };

  const calculateTotalSum = () => {
    if (!Array.isArray(tableData)) {
      // Handle invalid responseData by setting total income to 0 or any fallback
      setTotalSum(0);
      return;
    }

    const sum = tableData.reduce((total, report) => {
      const reportTotal = Number(report.Total);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalSum(sum);
  };

  const calculateSubtotalSum = () => {
    if (!Array.isArray(tableData)) {
      // Handle invalid responseData by setting total income to 0 or any fallback
      setSubTotalSum(0);
      return;
    }

    const sum = tableData.reduce((total, report) => {
      const reportSubtotal = Number(report.Subtotal);

      if (typeof reportSubtotal === "number" && !isNaN(reportSubtotal)) {
        return total + reportSubtotal;
      } else {
        return total;
      }
    }, 0);

    setSubTotalSum(sum);
  };

  const calculateProfitSum = () => {
    if (!Array.isArray(tableData)) {
      // Handle invalid responseData by setting total income to 0 or any fallback
      setProfitSum(0);
      return;
    }

    const sum = tableData.reduce((total, report) => {
      const reportProfit = Number(report.Profit);

      if (typeof reportProfit === "number" && !isNaN(reportProfit)) {
        return total + reportProfit;
      } else {
        return total;
      }
    }, 0);

    setProfitSum(sum);
  };

  useEffect(() => {
    calculateTotalSum();
    calculateSubtotalSum();
    calculateProfitSum();
  }, [tableData]);

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        return res;
      });

    axios
      .get(`${config.reportsBaseUrl}/reports/receivingcustomreportoptions`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedOption======>", res);
        const formattedData = res.data.ResponseData.map((item) => ({
          value: item.ID,
          label: item.Name,
        }));
        setSelectedOption(formattedData);
        console.log(formattedData, "formattedData");
      });

    axios
      .get(`${config.reportsBaseUrl}/reports/customreportconditions`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedCondition======>", res);
        const formattedConditions = res.data.ResponseData.map((item) => ({
          value: item.ID,
          label: item.Name,
        }));
        setSelectedCondition(formattedConditions);
      });

    // customer drop down
    // axios
    //   .get(`${config.customersBaseUrl}/customers/customerdropdown`, {
    //     headers: {
    //       "Content-Type": "application/json;charset=UTF-8",
    //       "Access-Control-Allow-Origin": "*",
    //       Authorization: token,
    //     },
    //   })
    //   .then((response) => {
    //     setCustOptions(response.data.ResponseData);
    //     console.log(response.data.ResponseData, "=====dataget>");
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });

    axios
      .get(`${config.generalBaseUrl}/generals/supplierdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((response) => {
        setSupOptions(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(`${config.employeesBaseUrl}/employees/usersdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("usersdropdown", res);
        setUsersDropdown(res.data.ResponseData);
        setLoading(false);

        return res;
      });

    axios
      .get(`${config.categoriesBaseUrl}/categories/categoriesdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSecondCategories(res.data.ResponseData);
      });

    axios
      .get(
        `${config.manufacturerBaseUrl}/manufacturers/manufacturersdropdown`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setManufactureDropdwon(res.data.ResponseData);
      });

    axios
      .get(`${config.storeConfigBaseUrl}/storeconfig/Roletierdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => setRoleTierDropDown(res.data.ResponseData))
      .catch((error) => console.log(error));
  }, []);

  console.log(selectedOption, "selectedOption15");

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
      if (event?.value === 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  console.log(reportdropdown, "reportdropdown");

  const addTableRows = () => {
    const rowsInput = {
      SelectectDropdownId: "",
      SelectectConditionId: "",
      SelectedOptions: "",
      SelectedItemRowsOptions: [],
    };

    setRowsData([...rowsData, rowsInput]);
  };

  const handleRemoveClick = (index) => {
    if (rowsData.length > 1) {
      const updatedRowsData = rowsData.filter((_, i) => i !== index);
      setRowsData(updatedRowsData);
    }
  };

  const handleSubmit = () => {
    // if (rowsData.SelectectConditionId == "") {
    //   toastError("Please select condition");
    //   return;
    // };

    if (rowsData.length > 0) {
      const filteredItems = rowsData.filter(
        (item) => item.SelectectConditionId === ""
      );

      if (filteredItems.length > 0) {
        toastError("Please select condition");
        return;
      }
    }

    console.log(startdate, "handleSubmitstartdate");
    console.log(enddate, "handleSubmitenddate");
    console.log(matchTypeId, "handleSubmitmatchTypeId");
    console.log(isReceiveItem, "handleSubmitisReceiveItem");
    console.log(rowsData, "handleSubmitrowsData");
    console.log(locationid, "handleSubmitLocationID");

    const Itemobj = {};

    Itemobj.rowsdataXML = rowsData;
    let itemjsonstring = JSON.stringify(Itemobj);

    const finalOnlySelectedItems =
      isOnlySelectedItem == 1 && isReceiveItem == 1 ? 1 : 0;

    let inputData = {
      startdate: startdate, //beginningDate,
      enddate: enddate, //finalDate,
      isReceiveItem: finalOnlySelectedItems,
      matchTypeId: matchTypeId,
      locationid: locationid,
      xmlrowdata: itemjsonstring,
    };

    console.log("inputData", inputData);

    setLoading(true);
    setTableData([]);
    axios
      .post(
        `${config.reportsBaseUrl}/reports/receivingcustomsearchreport`,
        inputData,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("setSelectedDate4545======>", res);
        setTableData(res.data.ResponseData?.TableData);
        setItemQuantityData(res.data.ResponseData?.ItemQuantity);
        setShowList([]);
        // const sum = res.data.ResponseData.reduce((acc, item) => acc + item.Total, 0);
        // setTotalSum(sum);
        setLoading(false);
        return res;
      });
  };

  const handleShowItemsData = (ReceivingId) => {
    const finalOnlyShowSelectedItems =
      isOnlySelectedItem == 1 && isReceiveItem == 1 ? 1 : 0;

    axios
      .get(
        // `${config.reportsBaseUrl}/reports/showReceiveItemsbyid?ReceivingId=${ReceivingId}&isReceiveItem=${isReceiveItem}&itemids=${ItemIds}`,
        `${config.reportsBaseUrl}/reports/showreceiveitemsbyid?receiveid=${ReceivingId}&isreceiveitem=${finalOnlyShowSelectedItems}&itemids=${checkedItems}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("ShowList======>", res);
        setShowList(res.data.ResponseData);
        return res;
      });
  };

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    setStartDate(payload);
    setEndDate(enddate2);

    console.log("enddate =>", enddate2);
  };

  const matchOptions = [
    { label: "Match all rules (AND condition)", value: 1 },
    { label: "Match any rule (OR condition)", value: 2 },
  ];

  const handleChangeMatchType = (event) => {
    console.log(event, "handleChangeMatchType");
    setMatchtype(event);
    setMatchTypeId(event?.value);
  };

  const handleItemCheckBox = (e) => {
    const isChecked = e.target.checked;
    setIsReceiveItem(isChecked == true ? 1 : 0);
  };

  const isOnlySelectedItem = rowsData.some(
    (row) => row.SelectectDropdownId === 5
  )
    ? 1
    : 0;
  const checkedItems = rowsData
    .filter((row) => row.SelectectDropdownId === 5)
    .map((row) => row.SelectedOptions);

  console.log(checkedItems, "checkedItems");

  const handleConditionChange = (index, event) => {
    let updateDate = [...rowsData];
    updateDate[index].SelectectConditionId = event.value;
    setRowsData(updateDate);
  };

  //   const handleCustomOptionChange = (index, event) => {
  //     let updateOption = [...rowsData];
  //     updateOption[index].SelectectDropdownId = event.value;
  //     setRowsData(updateOption);
  //   };

  //   const [filteredOptions, setFilteredOptions] = useState([]);

  const handleCustomOptionChange = (index, event) => {
    let updateOption = [...rowsData];
    updateOption[index].SelectectDropdownId = event.value;

    // Apply the filtering logic
    const newFilteredOptions = selectedCondition.filter((option) => {
      console.log(rowsData[index].SelectectDropdownId, "checking");
      if (
        [1, 2, 5, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18].includes(
          updateOption[index].SelectectDropdownId
        )
      ) {
        return ![3, 4, 5, 6, 7, 10, 11].includes(option.value);
      } else if ([3].includes(updateOption[index].SelectectDropdownId)) {
        return [10, 11].includes(option.value);
      } else if ([4].includes(updateOption[index].SelectectDropdownId)) {
        return [3, 4, 5, 11].includes(option.value);
      } else if ([6].includes(updateOption[index].SelectectDropdownId)) {
        return [1, 2, 3, 4, 5, 11].includes(option.value);
      } else if ([11].includes(updateOption[index].SelectectDropdownId)) {
        return [1].includes(option.value);
      }
      return true;
    });

    // Update rowsData and filtered options
    setRowsData(updateOption);
    setFilteredOptions(newFilteredOptions); // Set filtered options to state
  };

  const handleDropdownchange = (event, index, itemsearch) => {
    console.log(event, index, itemsearch, "event, index, itemsearch");
    let updateOption = [...rowsData];
    updateOption[index].SelectedOptions = event.map((e) => e.value).join(",");
    if (itemsearch) {
      updateOption[index].SelectedItemRowsOptions = event;
    }

    console.log(updateOption, "updateOptioncust");

    setRowsData(updateOption);
    setSelectedLabels(updateOption[index].SelectedItemRowsOptions);
  };

  const customerDropDown = custoptions.map((option) => ({
    value: option.Id,
    label:
      option.CompanyName +
      " (" +
      (option.FirstName + " " + option.LastName) +
      ")",
    address: option.Address1,
    email: option.Email,
  }));

  console.log(customerDropDown, "customerDropDown");

  let Catagories = [];
  const ItemCategories = SecondCategories.map((u, i) => {
    Catagories[i] = { label: u.Name, value: u.ID };
  });

  console.log(customerDropDown, "customerDropDown");

  console.log(supoptions, "supplierdata==>");
  const supOptions = supoptions.map((option) => ({
    value: option.ID,
    label:
      option.CompanyName +
      " (" +
      (option.FirstName + " " + option.LastName) +
      ")",
    email: option.Email,
    Address1: option.Address1,
    PhoneNumber: option.PhoneNumber,
  }));

  let usersDropdownOption = [];
  const userDropdown = usersDropdown.map((u, i) => {
    usersDropdownOption[i] = { label: u.Name, value: u.Id };
  });

  let Manufacturerdropdown = [];
  const manufacturesDropdown = manufacturedropdwonData.map((u, i) => {
    Manufacturerdropdown[i] = { label: u.Name, value: u.ID };
  });

  let RoleTierDropdownOption = [];
  const RolesTierDropdown = roletierdropdown.map((u, i) => {
    RoleTierDropdownOption[i] = { label: u.Name, value: u.ID };
  });

  console.log(manufacturedropdwonData, "Manufacturerdropdown");

  console.log(rowsData, "rowsData");

  const handelItemSearch = (value) => {
    if (value != "") {
      setSuggestions([]);
      axios
        .get(
          `${
            config.itemsBaseUrl
          }/items/searchforaccount?searchparam=${encodeURIComponent(
            value
          )}&iscategory=${0}&customerid=${0}&supplierid=${0}&locationid=${locationid}&itemsearchtype=sale&isservice=${1}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          console.log(res.data.ResponseData, "resdata2709");
          if (res.data.ResponseData.length > 0) {
          const modifiedData = res.data.ResponseData.map((item) => ({
            ...item,
            ID: item.ItemId,
            VariationId: item.VariationId,
            Name: item.VariationName != "" ? item.VariationName : item.ItemName,
            ImageURL: item.ImageName,
            Quantity:
              item.VariationId != 0
                ? item.VariationQuantity
                : item.Itemquantity,
            Categoryfullpath: item.CategoryName,
          }));
          setSuggestions(modifiedData);
          setLoading(false);
          } else {
            toastWarn("No Item Found");
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
        });
    } else {
      setSuggestions([]);
    }
  };

  const handelParentItemSearch = (value) => {
    if (value != "") {
      setSuggestions([]);
      axios
        .get(
          `${
            config.itemsBaseUrl
          }/items/searchitem?searchparam=${encodeURIComponent(value)}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          console.log(res.data.ResponseData, "resdata2709");
          const modifiedData = res.data.ResponseData.map((item) => ({
            ...item,
            ID: item.ItemId,
            VariationId: 0,
            Name: item.ItemName,
            ImageURL: item.images,
            Quantity: item.itemquantity,
            Categoryfullpath: item.CategoryPath,
          }));
          setSuggestions(modifiedData);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    } else {
      setSuggestions([]);
    }
  };

  const handleInputClick = (item, rowDataIndex) => {
    setSearchItemName("");
    setSearchParentItem("");
    // setItemInputValues([]);

    let updateOption = [...rowsData];

    const latestData = [
      ...updateOption[rowDataIndex].SelectedItemRowsOptions,
      {
        label: item.Name,
        value: item.VariationId > 0 ? item.VariationId + "V" : item.ID + "I",
        Type: item.VariationId > 0 ? "Variation" : "Item",
      },
    ];
    // Remove duplicates based on the 'value' property
    const uniqueData = latestData.filter(
      (v, i, a) => a.findIndex((t) => t.value === v.value) === i
    );

    // setItemInputValues(uniqueData);

    // let updateOption = [...rowsData];
    updateOption[rowDataIndex].SelectedOptions = uniqueData
      .map((e) => e.value)
      .join(",");
    updateOption[rowDataIndex].SelectedItemRowsOptions = uniqueData;
    console.log(uniqueData, "uniqueData");
    setRowsData(updateOption);
    setSelectedLabels(uniqueData);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      handelItemSearch(searchItemName);
    }, 1000);

    // Cleanup function to clear the timeout if the component unmounts
    // or if searchItemName changes before the delay completes
    return () => {
      clearTimeout(handler);
    };
  }, [searchItemName]);

  useEffect(() => {
    const handler = setTimeout(() => {
      handelParentItemSearch(searchParentItem);
    }, 1000);

    // Cleanup function to clear the timeout if the component unmounts
    // or if searchParentItem changes before the delay completes
    return () => {
      clearTimeout(handler);
    };
  }, [searchParentItem]);

  console.log(PERMISSION_SHOW_PROFIT_PRICE, "PERMISSION_SHOW_PROFIT_PRICE");

  console.log(selectedLabels, "12545455444");

  const row = rowsData.find((el) => el.SelectectDropdownId == 5);

  const mergedData =
    row && row.SelectedItemRowsOptions
      ? row.SelectedItemRowsOptions.map((label) => {
          // Ensure that label.value exists and is a string
          const id = label.value ? label.value.slice(0, -1) : "";

          // Find matching item or variation from itemQuantityData
          let matchedItem;
          if (label.Type === "Variation") {
            matchedItem = itemQuantityData.find(
              (item) => item.ItemvariationId.toString() === id
            );
          } else if (label.Type === "Item") {
            matchedItem = itemQuantityData.find(
              (item) => item.ItemId.toString() === id
            );
          }

          // If a match is found, add the quantity key
          return {
            ...label,
            QuantityReceived: matchedItem ? matchedItem.QuantityReceived : null,
          };
        })
      : [];

  console.log(mergedData, "mergedDatamergedData");

  const columns = useMemo(() => [
    {
      header: "Receiving Id",
      accessorKey: "ReceivingId",

      size: "150",
      //    filterFn : "contains",
      Cell: ({ row }) => (
        <>
          <Link
            className="text-warning word-break-data"
            to={`/receiving-receipt/${row.original.ReceivingId}`}
            target="_blank"
          >
            <Box
              component="span"
              sx={(theme) => ({
                borderRadius: "0.3rem",
                color: "#343f62",
                maxWidth: "18ch",
                fontWeight: "700",
                textDecoration: "underline",
                textUnderlineOffset: "3px",
                p: "0.3rem",
                cursor: "pointer",
              })}
            >
              {row.original.ReceivingId}
            </Box>
          </Link>
        </>
      ),
    },
    {
      header: "Location",
      accessorKey: "Location",
      //   size:"110",
      //    filterFn : "contains",
    },
    {
      header: "Date",
      accessorKey: "Date",
      size: "110",
      //    filterFn : "contains",
      Cell: ({ row }) =>
        moment(row.original.Date).format("MM/DD/YYYY h:mm A") === "Invalid date"
          ? ""
          : moment(row.original.Date).format(
              `${dateFormate.toUpperCase()} h:mm A`
            ),
    },
    {
      header: "Items Received",
      accessorKey: "ItemsReceived",
      size: "110",
    },
    {
      header: "Received By",
      accessorKey: "ReceivedBy",
      size: "130",
    },
    {
      header: "Supplied by",
      accessorKey: "ReceivedFrom",
    },
    {
      header: "Subtotal",
      accessorKey: "Subtotal",
      size: "130",
      Cell: ({ row }) => {
        return CurrencySymbols(
          Number(row.original.Subtotal),
          CurrencySymbol,
          FractionDigits
        );
      },
    },
    {
      header: "Total",
      accessorKey: "Total",
      size: "130",
      Cell: ({ row }) => {
        return CurrencySymbols(
          Number(row.original.Total),
          CurrencySymbol,
          FractionDigits
        );
      },
    },
    // {
    //   header: "Tax",
    //   accessorKey: "Date",
    // },

    //   ...(
    //     checkUserPermission(PERMISSION_SHOW_PROFIT_PRICE) ?
    //     [{
    //       header: "Profit",
    //       accessorKey: "Profit",
    //       size: "130",
    //     }]:[]
    //   ),
    {
      header: "Status",
      accessorKey: "Status",
      size: "130",
    },
    {
      header: "Comments",
      accessorKey: "Comments",
    },
    {
      header: "	Discount Reason",
      accessorKey: "DiscountReason",
    },
    {
      header: "Return Reason",
      accessorKey: "ReturnReason",
    },
    {
      header: "Address",
      accessorKey: "Address",
    },
  ]);

  const renderDetailPanel = ({ row }) => (
    // <Box
    //   sx={{
    //     alignItems: "center",
    //     display: "flex",
    //     justifyContent: "space-around",
    //     left: "30px",
    //     maxWidth: "1000px",
    //     position: "sticky",
    //     width: "100%",
    //   }}
    // >
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>Item Number</TableCell>
            <TableCell>ProductID</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Category</TableCell>
            <TableCell>Current Cost Price</TableCell>
            <TableCell>Quantity Received</TableCell>
            <TableCell>Subtotal</TableCell>
            <TableCell>Total</TableCell>
            {/* {checkUserPermission(PERMISSION_SHOW_PROFIT_PRICE) && (
                  <TableCell>Profit </TableCell>
                )} */}
            {checkUserPermission(PERMISSION_SHOW_COST_PRICE) && (
              <TableCell>Cost Price </TableCell>
            )}
            <TableCell>Discount</TableCell>
            <TableCell>Size</TableCell>
            <TableCell>Description</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {showList.map((row) => (
            <TableRow
              key={row.name}
              // sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell>{row.ItemNumber}</TableCell>
              <TableCell>{row.ProductId}</TableCell>
              <TableCell>{row.ItemName}</TableCell>
              <TableCell>{row.Category}</TableCell>
              {/* <TableCell>{row.CurrentCostPrice}</TableCell> */}
              <TableCell>
                {CurrencySymbols(
                  Number(row.CurrentCostPrice),
                  { CurrencySymbol },
                  FractionDigits
                )}
              </TableCell>
              <TableCell>{row.QuantitySold}</TableCell>
              <TableCell>
                {CurrencySymbols(
                  Number(row.CurrentCostPrice),
                  { CurrencySymbol },
                  FractionDigits
                )}
              </TableCell>
              <TableCell>
                {CurrencySymbols(
                  Number(row.Total),
                  { CurrencySymbol },
                  FractionDigits
                )}
              </TableCell>
              {/* {checkUserPermission(PERMISSION_SHOW_PROFIT_PRICE) && (
                    <TableCell>{row.Profit}</TableCell>
                  )} */}
              {checkUserPermission(PERMISSION_SHOW_COST_PRICE) && (
                <TableCell>
                  {CurrencySymbols(
                    Number(row.CostPrice),
                    { CurrencySymbol },
                    FractionDigits
                  )}
                </TableCell>
              )}
              <TableCell>{row.Discount}</TableCell>
              <TableCell>{row.Size}</TableCell>
              <TableCell>{row.Description}</TableCell>
              {/* <TableCell align="right">{row.Size}</TableCell> */}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    // </Box>
  );

  const processedReceivingIds = new Set();

  const muiExpandButtonProps = ({ row, table }) => {
    console.log(row, table, "rowtabledata");

    const ReceivingId = row.original.ReceivingId;
    return {
      onClick: () => {
        // Check if this ReceivingId has already been processed
        if (!processedReceivingIds.has(ReceivingId)) {
          // Call your function
          handleShowItemsData(ReceivingId);

          // Mark this ReceivingId as processed
          processedReceivingIds.add(ReceivingId);
        }

        // Set only this row to be expanded
        table.setExpanded({ [row.id]: !row.getIsExpanded() });
      },
    };
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Customer Balance Detail</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Receiving Custom Report
                </li>
              </ul>
            </div>
          </div>
          <div class="card mt-3">
            <div class="card-body">
              <div class="container">
                <div class="col-md-12 " id="header">
                  <div
                    className="col-md-10"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "1rem",
                    }}
                  >
                    {/* <div className=" col-md-3">
                      <div className="col-form-label">Report Period:</div>
                      <Select
                        onChange={(event) => {
                          handleDateFilter(event);
                        }}
                        // placeholder="Select Due Date"
                        options={dateOptions}
                        backspaceRemovesValue={false}
                        controlShouldRenderValue={true}
                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        value={dateOptions.find(
                          (el) => el?.value == customeDate
                        )}
                        isOptionDisabled={(option) => option.value == 0}
                        className="custom-search-select"
                      />
                    </div>
                    {customeDate != 8 && (
                      <>
                        <div className="col-md-2">
                          <div className="col-form-label">From:</div>
                          <CommonDatePicker
                            FinalDate={beginningDate}
                            handleDateChange={handleDate}
                          />
                        </div>
                        <div className="col-md-2">
                          <div className="col-form-label">To: </div>
                          <CommonDatePicker
                            FinalDate={finalDate}
                            handleDateChange={handleEndDate}
                          />
                        </div>
                      </>
                    )} */}
                    <div className="col-sm-3">
                      <label className="col-form-label col-md-12 form-label p-lg-medium">
                        Report Period
                      </label>
                      <div className="row">
                        <div className="col-md-12 z-4">
                          <Select
                            styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                            options={reportdropdown}
                            backspaceRemovesValue={false}
                            controlShouldRenderValue={true}
                            hideSelectedOptions={true}
                            // isClearable={true}
                            name="Reportperiod"
                            id="Reportperiod"
                            value={reportdropdown.find(
                              (e) => e.value === selectReport
                            )}
                            onChange={(event) => {
                              handleDropdownChange(event);
                            }}
                            className="custom-search-select"
                          ></Select>
                        </div>
                      </div>
                    </div>
                    {selectReport !== 1 && (
                      <div className="col-sm-4">
                        <div className="row">
                          <ReportDate
                            callback={callback}
                            selectReport={selectReport}
                            showhidecomponent={
                              selectReport == 2 ||
                              selectReport == 3 ||
                              selectReport == 4 ||
                              selectReport == 5 ||
                              selectReport == 6 ||
                              selectReport == 7 ||
                              selectReport == 8 ||
                              selectReport == 9 ||
                              selectReport == 10 ||
                              selectReport == 11 ||
                              selectReport == 12 ||
                              selectReport == 13 ||
                              selectReport == 14 ||
                              selectReport == 15 ||
                              selectReport == 16 ||
                              selectReport == 17 ||
                              selectReport == 18 ||
                              selectReport == 19 ||
                              selectReport == 20 ||
                              selectReport == 21 ||
                              selectReport == 22 ||
                              selectReport == 23 ||
                              selectReport == 24 ||
                              selectReport == 25 ||
                              selectReport == 26 ||
                              selectReport == 27 ||
                              selectReport == 28 ||
                              selectReport == 29 ||
                              selectReport == 30 ||
                              selectReport == 31
                                ? true
                                : false
                            }
                          />
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="row">
                    <div className="col-sm-3">
                      <label className="col-form-label col-md-5 form-label p-lg-medium">
                        Match Type:
                      </label>
                      <div className="row">
                        <div className="col-md-11 z-3">
                          <Select
                            onChange={(event) => {
                              handleChangeMatchType(event);
                            }}
                            options={matchOptions}
                            value={matchOptions.find(
                              (e) => e.value === matchTypeId
                            )}
                            backspaceRemovesValue={false}
                            controlShouldRenderValue={true}
                            hideSelectedOptions={true}
                            // isClearable={true}
                            styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                            className="custom-search-select mt-1"
                          />
                        </div>
                      </div>
                    </div>
                    <label
                      className="col-form-label col-md-2 form-label p-lg-medium"
                      style={{ marginTop: "5px" }}
                    >
                      Show Only Matched Items In Receive:
                    </label>
                    <div
                      style={{
                        width: "30px",
                        marginTop: "20px",
                        marginRight: "2px",
                      }}
                    >
                      <input
                        type="checkbox"
                        id="IsSubCust"
                        name="IsSubCust"
                        value="true"
                        checked={isReceiveItem}
                        style={{
                          height: "20px",
                          width: "20px",
                        }}
                        onChange={(e) => {
                          handleItemCheckBox(e);
                        }}
                      />
                    </div>
                    <hr className="mt-5"></hr>
                    <table className="table mt-3">
                      {rowsData?.map((item, index) => {
                        return (
                          <>
                            <tr>
                              <td style={{ width: "220px" }}>
                                <Select
                                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                  options={selectedOption}
                                  backspaceRemovesValue={false}
                                  controlShouldRenderValue={true}
                                  hideSelectedOptions={false}
                                  value={selectedOption.find(
                                    (el) => el.value == item.SelectectDropdownId
                                  )}
                                  onChange={(event) =>
                                    handleCustomOptionChange(index, event)
                                  }
                                />
                              </td>
                              <td style={{ width: "160px" }}>
                                <Select
                                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                  options={filteredOptions}
                                  backspaceRemovesValue={false}
                                  controlShouldRenderValue={true}
                                  hideSelectedOptions={false}
                                  value={selectedCondition.find(
                                    (el) =>
                                      el.value == item.SelectectConditionId
                                  )}
                                  onChange={(event) =>
                                    handleConditionChange(index, event)
                                  }
                                  className="w-100 custom-search-select"
                                  isDisabled={
                                    rowsData[index].SelectectDropdownId === ""
                                  }
                                />
                              </td>
                              {item.SelectectDropdownId != 1 &&
                                item.SelectectDropdownId != 3 &&
                                item.SelectectDropdownId != 2 &&
                                item.SelectectDropdownId != 5 &&
                                item.SelectectDropdownId != 9 &&
                                item.SelectectDropdownId != 11 &&
                                item.SelectectDropdownId != 12 &&
                                item.SelectectDropdownId != 8 && (
                                  <td>
                                    <div key={index}>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm border-size-input"
                                        value={item.inputFilterValue} // Controlled input for each row
                                        onChange={(e) =>
                                          handleInputChange(e, index)
                                        } // Handle change for specific index
                                      />
                                    </div>
                                  </td>
                                )}
                              {/* {item.SelectectDropdownId == 1 && ( //CustomerName
                                  <td>
                                    <div>
                                      <Select
                                        onChange={(event) =>
                                          handleDropdownchange(event, index)
                                        }
                                        options={customerDropDown}
                                        value={customerDropDown.find(
                                          (el) => el.value == item.SelectedOptions
                                        )}
                                        isMulti
                                        backspaceRemovesValue={false}
                                        controlShouldRenderValue={true}
                                        isClearable={true}
                                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                        className="custom-search-select mt-1"
                                      />
                                    </div>
                                  </td>
                                )} */}
                              {item.SelectectDropdownId == 8 && (
                                <td>
                                  <div>
                                    <Select
                                      onChange={(event) =>
                                        handleDropdownchange(event, index)
                                      }
                                      options={usersDropdownOption}
                                      value={usersDropdownOption.find(
                                        (el) => el.value == item.SelectedOptions
                                      )}
                                      backspaceRemovesValue={false}
                                      controlShouldRenderValue={true}
                                      isClearable={true}
                                      isMulti={true}
                                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                      id="userDropdown"
                                      name="userDropdown"
                                    />
                                  </div>
                                </td>
                              )}
                              {/* {item.SelectectDropdownId == 8 && (
                                  <td>
                                    <div>
                                      <Select
                                        onChange={(event) =>
                                          handleDropdownchange(event, index)
                                        }
                                        options={usersDropdownOption}
                                        value={usersDropdownOption.find(
                                          (el) => el.value == item.SelectedOptions
                                        )}
                                        backspaceRemovesValue={false}
                                        controlShouldRenderValue={true}
                                        isClearable={true}
                                        isMulti={true}
                                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                        id="userDropdown"
                                        name="userDropdown"
                                      />
                                    </div>
                                  </td>
                                )} */}
                              {item.SelectectDropdownId == 2 && (
                                <td>
                                  <div>
                                    <Select
                                      onChange={(event) =>
                                        handleDropdownchange(event, index)
                                      }
                                      options={Catagories}
                                      value={Catagories.find(
                                        (el) => el.value == item.SelectedOptions
                                      )}
                                      backspaceRemovesValue={false}
                                      controlShouldRenderValue={true}
                                      hideSelectedOptions={true}
                                      isClearable={true}
                                      isMulti
                                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                      id="Category"
                                      name="Category"
                                      className="w-100 custom-search-select"
                                    />
                                  </div>
                                </td>
                              )}
                              {item.SelectectDropdownId == 1 && (
                                <td>
                                  <div>
                                    <Select
                                      onChange={(event) =>
                                        handleDropdownchange(event, index)
                                      }
                                      options={supOptions}
                                      value={supOptions.find(
                                        (el) => el.value == item.SelectedOptions
                                      )}
                                      isMulti
                                      backspaceRemovesValue={false}
                                      controlShouldRenderValue={true}
                                      isClearable={true}
                                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                      className="custom-search-select mt-1"
                                      filterOption={(candidate, input) => {
                                        const searchText = input.toLowerCase();
                                        const {
                                          label,
                                          Address1,
                                          PhoneNumber,
                                          email,
                                        } = candidate.data; // Access additional fields
                                        return (
                                          label.toLowerCase().includes(searchText) || // Search by name
                                          Address1?.toLowerCase().includes(searchText) || // Search by address
                                          PhoneNumber?.toLowerCase().includes(searchText) || // Search by email
                                          email?.toLowerCase().includes(searchText)  // Search by email
                                        );
                                      }}
                                    />
                                  </div>
                                </td>
                              )}
                              {item.SelectectDropdownId == 9 && (
                                <td>
                                  <div>
                                    <Select
                                      onChange={(event) =>
                                        handleDropdownchange(event, index)
                                      }
                                      options={Manufacturerdropdown}
                                      value={Manufacturerdropdown.find(
                                        (el) => el.value == item.SelectedOptions
                                      )}
                                      backspaceRemovesValue={false}
                                      controlShouldRenderValue={true}
                                      isClearable={true}
                                      isMulti={true}
                                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                      id="Manufacturer"
                                      name="Manufacturer"
                                    />
                                  </div>
                                </td>
                              )}

                              {/* {item.SelectectDropdownId == 17 && (
                                  <td>
                                    <div>
                                      <Select
                                        onChange={(event) =>
                                          handleDropdownchange(event, index)
                                        }
                                        options={RoleTierDropdownOption}
                                        value={RoleTierDropdownOption.find(
                                          (el) => el.value == item.SelectedOptions
                                        )}
                                        backspaceRemovesValue={false}
                                        controlShouldRenderValue={true}
                                        isClearable={true}
                                        isMulti={true}
                                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                      />
                                    </div>
                                  </td>
                                )} */}
                              {item.SelectectDropdownId == 5 && (
                                <td>
                                  <div className="d-flex justify-content-between gap-2">
                                    <div>
                                      <input
                                        type="search"
                                        placeholder="Search..."
                                        // className="form-control-sm w-100 mt-1"
                                        className="search-btn form-control form-control-sm"
                                        onChange={(e) => {
                                          setSearchItemName(e.target.value);
                                        }}
                                        value={searchItemName}
                                        style={{ width: "300px" }}
                                      />
                                      {suggestions?.length > 0 ? (
                                        <>
                                          <div className="dropdown">
                                            <ul
                                              className="dropdown-menu show dropdown-suggestion"
                                              style={{
                                                overflow: "auto",
                                                width: "120% ",
                                                maxWidth: "600px",
                                              }}
                                            >
                                              {suggestions?.map((item) => (
                                                <li
                                                  className="border-bottom"
                                                  key={item.ID}
                                                  onClick={(e) => {
                                                    // setSelectedLabels(item.SelectedItemRowsOptions);
                                                    handleInputClick(
                                                      item,
                                                      index
                                                    );
                                                  }}
                                                >
                                                  <Link
                                                    key={item.ID}
                                                    href="#"
                                                    class="dropdown-item"
                                                    data-name={item.Name?.toLowerCase()}
                                                  >
                                                    <img
                                                      src={
                                                        item.ImageURL || Noimage
                                                      }
                                                      onError={(e) => {
                                                        e.currentTarget.src =
                                                          Noimage;
                                                      }}
                                                      alt={item.Name}
                                                      className="img-thumbnail rounded-circle mr-4"
                                                      width="55"
                                                      height="55"
                                                      style={{
                                                        height: "60px",
                                                        objectFit: "contain",
                                                      }}
                                                    />
                                                    <div className="customer-info w-100">
                                                      <strong
                                                        className="word-break-data"
                                                        style={{
                                                          fontWeight: "bold",
                                                          color: "#333",
                                                        }}
                                                      >
                                                        {item.Name}{" "}
                                                        {item.Name
                                                          ? `(${item.Name})`
                                                          : ""}
                                                      </strong>
                                                    </div>
                                                  </Link>
                                                </li>
                                              ))}
                                            </ul>
                                          </div>
                                        </>
                                      ) : null}
                                    </div>
                                    <div key={index} style={{ width: "270px" }}>
                                      <Select
                                        onChange={(event) => {
                                          // setSelectedLabels(item.SelectedItemRowsOptions);
                                          handleDropdownchange(
                                            event,
                                            index,
                                            "itemsearch"
                                          );
                                        }}
                                        options={item.SelectedItemRowsOptions}
                                        value={item.SelectedItemRowsOptions}
                                        isMulti
                                        backspaceRemovesValue={false}
                                        controlShouldRenderValue={true}
                                        isClearable={true}
                                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                        className="custom-search-select"
                                      />
                                    </div>
                                  </div>
                                </td>
                              )}
                              {item.SelectectDropdownId == 11 && (
                                <td>
                                  <div className="d-flex justify-content-between gap-2">
                                    <div>
                                      <input
                                        type="search"
                                        placeholder="Search..."
                                        // className="form-control-sm w-100 mt-1"
                                        className="search-btn form-control form-control-sm"
                                        onChange={(e) => {
                                          setSearchParentItem(e.target.value);
                                        }}
                                        value={searchParentItem}
                                        style={{ width: "300px" }}
                                      />
                                      {suggestions?.length > 0 ? (
                                        <>
                                          <div className="dropdown">
                                            <ul
                                              className="dropdown-menu show dropdown-suggestion"
                                              style={{
                                                overflow: "auto",
                                                width: "120% ",
                                                maxWidth: "600px",
                                              }}
                                            >
                                              {suggestions?.map((item) => (
                                                <li
                                                  className="border-bottom"
                                                  key={item.ID}
                                                  onClick={(e) => {
                                                    // setSelectedLabels(item.SelectedItemRowsOptions);
                                                    handleInputClick(
                                                      item,
                                                      index
                                                    );
                                                  }}
                                                >
                                                  <Link
                                                    key={item.ID}
                                                    href="#"
                                                    class="dropdown-item"
                                                    data-name={item.Name?.toLowerCase()}
                                                  >
                                                    <img
                                                      src={
                                                        item.ImageURL || Noimage
                                                      }
                                                      onError={(e) => {
                                                        e.currentTarget.src =
                                                          Noimage;
                                                      }}
                                                      alt={item.Name}
                                                      className="img-thumbnail rounded-circle mr-4"
                                                      width="55"
                                                      height="55"
                                                      style={{
                                                        height: "60px",
                                                        objectFit: "contain",
                                                      }}
                                                    />
                                                    <div className="customer-info w-100">
                                                      <strong
                                                        className="word-break-data"
                                                        style={{
                                                          fontWeight: "bold",
                                                          color: "#333",
                                                        }}
                                                      >
                                                        {item.Name}{" "}
                                                        {item.Name
                                                          ? `(${item.Name})`
                                                          : ""}
                                                      </strong>
                                                    </div>
                                                  </Link>
                                                </li>
                                              ))}
                                            </ul>
                                          </div>
                                        </>
                                      ) : null}
                                    </div>
                                    <div key={index} style={{ width: "270px" }}>
                                      <Select
                                        onChange={(event) => {
                                          // setSelectedLabels(item.SelectedItemRowsOptions);
                                          handleDropdownchange(
                                            event,
                                            index,
                                            "itemsearch"
                                          );
                                        }}
                                        options={item.SelectedItemRowsOptions}
                                        value={item.SelectedItemRowsOptions}
                                        isMulti
                                        backspaceRemovesValue={false}
                                        controlShouldRenderValue={true}
                                        isClearable={true}
                                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                        className="custom-search-select"
                                      />
                                    </div>
                                  </div>
                                </td>
                              )}

                              {item.SelectectDropdownId == 16 && (
                                <td>
                                  <div className="d-flex justify-content-between gap-2">
                                    <input
                                      type="search"
                                      placeholder="Search..."
                                      // className="form-control-sm w-100 mt-1"
                                      className="search-btn form-control form-control-sm w-50"
                                      onChange={(e) => {
                                        setSearchItemName(e.target.value);
                                      }}
                                      // value={searchItemName}
                                      style={{ width: "300px" }}
                                    />
                                    <div key={index} style={{ width: "300px" }}>
                                      {/* <input
                                          type="text"
                                          className="form-control form-control-sm border-size-input"
                                          value={item.inputFilterValue} // Controlled input for each row
                                          onChange={(e) =>
                                            handleInputChange(e, index)
                                          } // Handle change for specific index
                                        /> */}
                                      <Select
                                        onChange={(event) =>
                                          handleDropdownchange(
                                            event,
                                            index,
                                            "itemsearch"
                                          )
                                        }
                                        options={item.SelectedItemRowsOptions}
                                        value={item.SelectedItemRowsOptions}
                                        isMulti
                                        backspaceRemovesValue={false}
                                        controlShouldRenderValue={true}
                                        isClearable={true}
                                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                        // style={{ width: "260px" }}
                                        className="custom-search-select"
                                      />
                                    </div>
                                  </div>
                                </td>
                              )}

                              <td>
                                {matchTypeId === 1 ? "AND" : "OR"}
                                <i
                                  class="fa fa-plus-circle"
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "17px",
                                    color: "#105b06",
                                  }}
                                  onClick={() => addTableRows()}
                                ></i>
                                <i
                                  class="fas fa-minus-circle"
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "15px",
                                    color: "red",
                                  }}
                                  onClick={() => handleRemoveClick(index)}
                                ></i>
                              </td>
                            </tr>
                          </>
                        );
                      })}
                    </table>
                  </div>
                  {/* </div> */}
                </div>
              </div>
              <div style={{ textAlign: "right", marginTop: "50px" }}>
                <button
                  class="btn btn-primary"
                  type="submit"
                  onClick={handleSubmit}
                >
                  Run Report
                </button>
              </div>
            </div>
          </div>
          <div
            className="row"
            style={{
              display: "grid",
              gap: "1rem",
              // gridTemplateColumns: "repeat(5,1fr)"
              gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            }}
          ></div>

          {/* Receipt */}

          <div className="card mt-3">
            <div className="card-body">
              <div className="container">
                <div className="col-md-12 text-center " id="header">
                  <h6 class="p">SonarPos</h6>
                  <p className="fw-bold p-regular">Receiving Custom Report</p>
                  <div className="row mb-2">
                    {/* <h6> Date: {new Date().toLocaleDateString()}</h6>
                            <p >
                              Date: {startdate} - {enddate}
                            </p> */}
                    <p>
                      Date:{" "}
                      {beginningDate === "" && finalDate === ""
                        ? "All Data"
                        : moment(beginningDate).format(
                            `${dateFormate.toUpperCase()}`
                          ) +
                          " - " +
                          moment(finalDate).format(
                            `${dateFormate.toUpperCase()}`
                          )}
                    </p>
                  </div>
                </div>
              </div>
              <hr />

              <div className="table-responsive">
                <div className="table mt-3"></div>

                <div>
                  <CommonMatrialReactTable
                    MainHeading="Sonar POS"
                    ReportHeading="Receiving Custom Report"
                    columns={columns}
                    data={tableData}
                    startdate={startdate}
                    enddate={enddate}
                    columnGrouping={[]}
                    columnsVisibility={{}}
                    renderDetailPanel={renderDetailPanel}
                    muiExpandButtonProps={muiExpandButtonProps}
                    // enableExpandAll={false}
                  />
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "5px",
                }}
              >
                {isReceiveItem == 1 && (
                  <div style={{ textAlign: "start" }}>
                    <Stack style={{ fontWeight: "bold" }}>
                      {mergedData.map((item, index) => (
                        <div key={index}>
                          {item.label}: {item.QuantityReceived} Qty
                        </div>
                      ))}
                    </Stack>
                  </div>
                )}

                <div style={{ textAlign: "end" }}>
                  <Stack style={{ fontWeight: "bold" }}>
                    {/* Subtotal: {subTotalSum.toFixed(2)} */}
                    Subtotal:{" "}
                    {CurrencySymbols(
                      Number(subTotalSum),
                      { CurrencySymbol },
                      FractionDigits
                    )}
                  </Stack>
                  <Stack style={{ fontWeight: "bold" }}>
                    Total:{" "}
                    {CurrencySymbols(
                      Number(totalSum),
                      { CurrencySymbol },
                      FractionDigits
                    )}
                  </Stack>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReceivingCustomReport;
